import { IWidgetChannels } from 'widget/entities/config/client';

import { IWidgetChannelServer } from './server';

export const normalizeWidgetChannels = (
  serverChannels: IWidgetChannelServer[]
): IWidgetChannels => {
  return serverChannels.map((channel) => ({
    kind: channel.type,
    url: channel.social_url
  }));
};
